import React from 'react';
import { Divider, Switch } from 'antd';
import { getSyncType } from 'common/helpers/getSyncType';
import ExternalId from './external-id';
import SyncTime from './sync-time';
import SyncType from './sync-type';

const SyncStatus = props => {
  const { t, externalSystem, externalId, time, link, history, switchProps } = props;

  if (!getSyncType(externalSystem)) {
    return null;
  }

  return (
    <>
      <div className="sync-status__item">
        <SyncType t={t} externalSystem={externalSystem} />
        {switchProps?.enabled && (
          <div>
            <Divider type="vertical" style={{ margin: '0 12px' }} />
            <Switch
              size="small"
              checked={switchProps?.checked}
              checkedChildren="On"
              unCheckedChildren="Off"
              onChange={switchProps?.onChange}
            />
          </div>
        )}
      </div>
      <div className="sync-status__item">
        <ExternalId t={t} externalId={externalId} />
      </div>
      <div className="sync-status__item">
        <SyncTime t={t} time={time} link={link} history={history} />
      </div>
    </>
  );
};

export default SyncStatus;
